// src/Chat.tsx
import { useEffect, useState } from 'react';
import { Container, Button, Text, Group, CopyButton, rem } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { useCompanyInfo } from '@contexts/company-info';
import type { AssistantMessage } from '@src/types/assistant';
import DataError from '@components/data-error';
import ErrorPageGeneral from '@components/error-page-general';
import { ChatMessages } from '@components/chat-messages';
import { useAssistant } from '@components/use-assistant';

function CreatingOkrs() {
  const companyInfo = useCompanyInfo();
  const location = useLocation();
  const currentThreadId = location.state?.threadId;
  const [botResponse, setBotResponse] = useState<string>('');
  const [threadId, setThreadId] = useState<string | null>(currentThreadId);
  const [assistantMessage, setAssistantMessage] = useState<AssistantMessage>({
    message: 'Please create my OKRs based on the company overview',
    threadId: currentThreadId,
  });

  const { data, loading, error } = useAssistant(assistantMessage, { skip: !companyInfo.company });

  useEffect(() => {
    // drop data in initial data
    if (!data?.threadId) return;
    setThreadId(data.threadId);
    setBotResponse(`${data?.message || 'No AI response. Please try again.'}`);
  }, [data]);

  if (!companyInfo.company) return <ErrorPageGeneral error={new Error('No company info found')} />;
  if (error) return <DataError error={error} />;

  return (
    <Container>
      {/* TODO <SubHeader /> */}
      <Text ta="center" p={rem(20)}>
        Here are your OKRs for <span style={{ fontWeight: 700 }}>{companyInfo.company?.name}</span>.
      </Text>
      <Text ta="center" mb={rem(20)}>
        Please let me know of any changes you'd like to make.
      </Text>

      <ChatMessages
        setAssistantMessage={setAssistantMessage}
        assistantMessage={assistantMessage}
        threadId={threadId}
        loading={loading}
        loadingText="Creating your OKRs..."
        botResponse={botResponse}
      />

      <Group justify="flex-end" pt={rem(40)} p={rem(0)} mb={rem(20)}>
        <Button variant="light" component={Link} to="/get-started">
          Back
        </Button>
        <Button component={Link} to="/" disabled={loading}>
          Home
        </Button>
        {/* <Button>Save</Button>
        <Button color="btb-navy">Export Results</Button> */}
        <CopyButton value={botResponse} timeout={2000}>
          {({ copied, copy }) => (
            <Button color={copied ? 'teal' : 'btb-navy'} onClick={copy} disabled={loading}>
              {copied ? 'Copied!' : 'Copy OKRs'}
            </Button>
          )}
        </CopyButton>
      </Group>
    </Container>
  );
}

export { CreatingOkrs };
